import * as d3 from "d3";
import { CubicBezier, } from "../d3-mapp/curve/index.js";
// export const getSpline = (
//   time: Timing,
//   data: d3.NumberValue[] | Iterable<d3.NumberValue>,
//   curveFactory: d3.CurveFactory
// ): Spline => {
//   const splineCtx = splineContext(time);
//   //define the curve
//   const line = d3
//     .line<d3.NumberValue>(
//       (_d, i) => time.get(i),
//       (d, _i) => d.valueOf()
//     )
//     .context(<CanvasRenderingContext2D>(<unknown>splineCtx))
//     .defined((datum, index, _dataList) => {
//       //let the bezier context know at which datum/index D3 is working at
//       splineCtx.indexTracker().setIndex(index);
//       //consider null datums to be not defined and there fore not be drawn
//       //this will result in calls to lineEnd and lineStart in the
//       //d3.CurveGenerator given below.
//       return datum != null;
//     })
//     //wrap the curveFactory we want to use. This way the Bezier context knows
//     //where a curve section is ending or starting
//     .curve(wrappedCurve(curveFactory, splineCtx.indexTracker()));
//   //seed the bezierContext with data
//   line(data);
//   //bezier context now holds all bezier sections that make up the time series (the data)
//   const seriesCurves = splineCtx.getCurves();
//   return seriesCurves;
// };
// const wrappedCurve = (
//   curveFactory: d3.CurveFactory,
//   indexTracker: IndexTracker
// ): d3.CurveFactoryLineOnly => {
//   return (context: CanvasRenderingContext2D | d3.Path): d3.CurveGenerator => {
//     return new WrappedCurveGenerator(curveFactory(context), indexTracker);
//   };
// };
//(context: CanvasRenderingContext2D | Path) => CurveGenerator;
/**
 * Here we wrap as it were a D3 curve generator. This Generator exposes the same
 * methods as the curve generator being wrapped.
 *
 * However we are only interested in the lineStart and lineEnd methods. When these
 * are called, we also call the 'TimeKeeper' to let it know when a line (curve actually)
 * is starting or ending.
 */
// class WrappedCurveGenerator implements d3.CurveGenerator {
//   /**
//    *
//    * @param curveGenerator
//    * @param timeKeeper
//    */
//   public constructor(
//     private curveGenerator: d3.CurveGenerator,
//     private indexTracker: IndexTracker
//   ) {}
//   /**
//    * Indicates the start of a new area segment.
//    * Each area segment consists of exactly two line segments: the topline, followed by the baseline, with the baseline points in reverse order.
//    */
//   areaStart(): void {
//     //console.log(`'areaStart called ${this.indexTracker.getIndex()}`);
//     this.curveGenerator.areaStart();
//   }
//   /**
//    * Indicates the end of the current area segment.
//    */
//   areaEnd(): void {
//     //console.log(`'areaEnd called ${this.indexTracker.getIndex()}`);
//     this.curveGenerator.areaEnd();
//   }
//   /**
//    * Indicates the start of a new line segment. Zero or more points will follow.
//    */
//   lineStart(): void {
//     //console.log(`'WrappedCurveGenerator lineStart called at index ${this.indexTracker.getIndex()}`);
//     this.indexTracker.markLineStart();
//     this.curveGenerator.lineStart();
//   }
//   /**
//    * Indicates the end of the current line segment.
//    */
//   lineEnd(): void {
//     //console.log(`'WrappedCurveGenerator lineEnd called at index ${this.indexTracker.getIndex()}`);
//     this.indexTracker.markLineEnd();
//     this.curveGenerator.lineEnd();
//   }
//   /**
//    * Indicates a new point in the current line segment with the given x- and y-values.
//    */
//   point(x: number, y: number): void {
//     //console.log(`'point called ${this.indexTracker.getIndex()}`);
//     this.curveGenerator.point(x, y);
//   }
// }
/**
 * Returns the value for given t and also returns the two dimensional index of
 * the BezierCurve that defines t. This index can be used as a call to this
 * function when t(n+x) >= t(n). This will speed up the lookup of values
 * when t increases monotonous on every next call.
 * @param milli the timestamp where to get the value for
 * @param spline the spline to search in
 * @param from the bezier curve within the spline to start with
 * @returns The coordinate at t (will be undefined when the spline is undefined for t)
 * and the index of the first bezier curve to start with if the next call is for a t
 * that is greater then the t in this call.
 */
export const getSplineValue = (milli, spline, from = [0, 0]) => {
    let value = undefined;
    const index = [from[0], from[1]];
    let foundT = false;
    if (spline && spline.length > 0) {
        if (CubicBezier.getStart(spline[0][0]).x <= milli) {
            //milli is on/after start of spline
            let splineCurve = undefined;
            //find spline curve that ends after milli
            while (index[0] < spline.length && !foundT) {
                splineCurve = spline[index[0]];
                const lastSection = splineCurve[splineCurve.length - 1];
                if (CubicBezier.getEnd(lastSection).x >= milli) {
                    //found spline curve that ends after milli
                    if (CubicBezier.getStart(splineCurve[0]).x <= milli) {
                        //milli is on/after start of spline curve
                        let curveSection = undefined;
                        //find curve section that ends after milli
                        while (index[1] < splineCurve.length && !foundT) {
                            curveSection = splineCurve[index[1]];
                            if (CubicBezier.getEnd(curveSection).x >= milli) {
                                //found section that ends after milli and holds milli
                                foundT = true;
                                const t = CubicBezier.tForX(curveSection, milli);
                                t.length > 0 ? CubicBezier.get(curveSection, t[0]) : undefined;
                            }
                            else {
                                //try next curve section
                                index[1]++;
                            }
                        }
                    } // milli before start of spline curve section (i.e.) milli is in between 2 sections of the spline
                }
                else {
                    //try next spline curve
                    index[0]++;
                    index[1] = 0;
                }
            }
        } // milli before start of spline
    } // no splines avail
    return { value, at: index };
};
/**
 * Returns the time range of the spline or a section of the spline.
 * @param spline The spline
 * @param sectionIndex optional section index. When undefined, the time range of the spline is returned.
 * @returns The time range.
 */
export const getSplineTimeRange = (spline, sectionIndex) => {
    const section = spline[sectionIndex !== undefined ? sectionIndex : 0];
    let timeRange = undefined;
    if (section) {
        const lastBC = section[section.length - 1];
        timeRange = { s: CubicBezier.getStart(section[0]).x, e: CubicBezier.getEnd(lastBC).x };
    }
    else {
        timeRange = undefined;
    }
    if (sectionIndex === undefined &&
        timeRange !== undefined &&
        spline.length > 1) {
        const lastSection = spline[spline.length - 1];
        const lastBC = lastSection[lastSection.length - 1];
        timeRange.e = CubicBezier.getEnd(lastBC).x;
    }
    return timeRange;
};
/**
 * Removes sections of the given spline that lie outside the given interval
 * @param spline The spline to clip
 * @param start The start of the interval
 * @param end The end of the interval
 * @returns The clipped spline.
 */
export const clipSpline = (spline, start, end) => {
    if (spline && spline.length > 0) {
        let part;
        if (start != null) {
            part = spline[0][spline[0].length - 1];
            //remove all sections that come before start
            while (part && CubicBezier.getEnd(part).x <= start) {
                spline.splice(0, 1);
                part = spline.length > 0 ? spline[0][spline[0].length - 1] : undefined;
            }
            if (spline.length > 0) {
                //there is still some left
                const section = spline[0];
                part = section[0];
                //remove all parts that come before start
                while (part && CubicBezier.getEnd(part).x <= start) {
                    section.splice(0, 1);
                    part = section.length > 0 ? section[0] : undefined;
                }
                if (part) {
                    //we need to split this part
                    if (start > CubicBezier.getStart(part).x) {
                        section.splice(0, 1, CubicBezier.splitAtX(part, start)[1]);
                    }
                }
            }
        }
        if (spline.length > 0 && end != null) {
            part = spline[spline.length - 1][0];
            //remove all sections that come after end
            while (part && CubicBezier.getStart(part).x >= end) {
                spline.splice(spline.length - 1, 1);
                part = spline.length > 0 ? spline[spline.length - 1][0] : undefined;
            }
            if (spline.length > 0) {
                //there is still some left
                const section = spline[spline.length - 1];
                part = section[section.length - 1];
                //remove all parts that come after end
                while (part && CubicBezier.getStart(part).x >= end) {
                    section.splice(section.length - 1, 1);
                    part = section.length > 0 ? section[section.length - 1] : undefined;
                }
                if (part) {
                    //we need to split this part
                    if (end < CubicBezier.getEnd(part).x) {
                        section.splice(section.length - 1, 1, CubicBezier.splitAtX(part, end)[0]);
                    }
                }
            }
        }
    }
    return spline;
};
/**
 * Takes the first spline of the given splines and fills gaps
 * found in this spline with the values taken from the other splines.
 * When no other values exist...the gap stays a gap. All the manipulations
 * are in place, meaning the original splines get altered.
 * @param splines The splines to merge together
 * @param start The starting timestamp where to get the resulting spline for
 * @param end The ending timestamp where to get the resulting spline for
 * @returns The merged spline for given interval. I.E. the first spline of the given list of splines.
 */
export const mergeSplines = (splines, start, end, index = 0) => {
    let sfList = Array.of(...splines);
    let spline = index >= 0 && index < sfList.length ? sfList[index].get() : undefined;
    if (spline) {
        clipSpline(spline, start, end);
        let mergeSpline = undefined;
        let ts = start;
        let i = 0;
        let sectionRange = getSplineTimeRange(spline, i);
        let te = sectionRange ? sectionRange.s : end;
        do {
            if (Math.abs(te - ts) > 0.1) {
                //allow for floating point imprecision
                //there is a gap between to consecutive path section
                //if we do have a spline to merge with but and it has not been created yet -> create it
                if (!mergeSpline && index + 1 < sfList.length) {
                    mergeSpline = mergeSplines(splines, start, end, index + 1);
                    //take a section of the alternative path to fill the gap
                    let gapAlternativeSection = mergeSpline.concat([]);
                    clipSpline(gapAlternativeSection, ts, te);
                    //fill in the gap with the alternative section for this gap
                    if (gapAlternativeSection.length > 0) {
                        spline.splice(i, 0, ...gapAlternativeSection);
                        i += gapAlternativeSection.length;
                        ts = getSplineTimeRange(gapAlternativeSection)?.e;
                    }
                }
                else {
                    //we are out of splines to merge with
                    sectionRange = undefined;
                }
            }
            //advance
            if (sectionRange) {
                i++;
                ts = sectionRange.e;
                sectionRange = getSplineTimeRange(spline, i);
                te = sectionRange ? sectionRange.s : end;
            }
            else {
                ts = end;
            }
        } while (ts < end);
        return spline;
    }
    else {
        throw new Error("Parameter splines should hold at least one SplineFactory.");
    }
};
export const getSplineDomain = (spline) => {
    if (spline && spline.length > 0) {
        if (spline[0].meta) {
            return spline.reduce((domain, pathSection) => {
                return pathSection.section.reduce((domain, bc) => {
                    if (domain[0] === undefined) {
                        domain[0] = Math.min(bc.cp[0].y, bc.cp[3].y);
                        domain[1] = Math.max(bc.cp[0].y, bc.cp[3].y);
                    }
                    else {
                        domain[0] = Math.min(domain[0], bc.cp[0].y, bc.cp[3].y);
                        domain[1] = Math.max(domain[1], bc.cp[0].y, bc.cp[3].y);
                    }
                    return domain;
                }, domain);
            }, [undefined, undefined]);
        }
        else {
            return spline.reduce((domain, section) => {
                return section.reduce((domain, bc) => {
                    if (domain[0] === undefined) {
                        domain[0] = Math.min(bc.cp[0].y, bc.cp[3].y);
                        domain[1] = Math.max(bc.cp[0].y, bc.cp[3].y);
                    }
                    else {
                        domain[0] = Math.min(domain[0], bc.cp[0].y, bc.cp[3].y);
                        domain[1] = Math.max(domain[1], bc.cp[0].y, bc.cp[3].y);
                    }
                    return domain;
                }, domain);
            }, [undefined, undefined]);
        }
    }
    return [undefined, undefined];
};
export const transformSpline = (spline, xScale, yScale) => {
    if (spline && spline.length > 0) {
        if (spline[0].meta) {
            //path is a Path
            spline.forEach((pathSection) => {
                pathSection.section.forEach((bezierCurve) => {
                    bezierCurve.cp.forEach((point) => {
                        point.x = xScale(point.x);
                        point.y = yScale(point.y);
                    });
                });
            });
        }
        else {
            //path is a Spline
            spline.forEach((splineSection) => {
                splineSection.forEach((bezierCurve) => {
                    bezierCurve.cp.forEach((point) => {
                        point.x = xScale(point.x);
                        point.y = yScale(point.y);
                    });
                });
            });
        }
    }
    return spline;
};
export const getSplineSectionScaler = (xScale, yScale) => {
    return (splineSection) => {
        return splineSection.map((bezierCurve) => {
            return Object.assign({}, bezierCurve, {
                cp: bezierCurve.cp.map((point) => {
                    return { x: xScale(point.x), y: yScale(point.y) };
                }),
            });
        });
    };
};
